import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { headerStyles as styles } from './header.tailwind';
import Button from '../shared/Button/Button';
import routeConstant from '../../lib/constants/routeConstant';
import { APP_LOGO_IMAGE } from '../../lib/constants/globalConstant';
import { MY_ACCOUNT_TABS } from '../MyAccount/myAccountTabsData';
import { connect, useSelector } from 'react-redux';
import { setMyAccountActiveTab } from '../../redux/slices/publicSlice';
import middleImage from '../../assets/svgs/georgia_tech_logo2.svg';

const Header = ({ showButton, buttonName, navUrl, setActiveTab, showMiddleImage, middleImage }) => {
  const navigate = useNavigate();
  const { isSignedIn } = useSelector((state) => state.user);
  return (
    <header className={styles.container}>
      {/* Left: Logo */}
      <Link to={isSignedIn ? routeConstant.MY_ACCOUNT_PAGE : "/"}
        onClick={() => {
          if (isSignedIn) {
            setActiveTab(MY_ACCOUNT_TABS.DEFAULT_TAB);
          }
        }}
      >
        <img src={APP_LOGO_IMAGE} alt="Logo" className={styles.logo} />
      </Link>

      {showMiddleImage && middleImage && (
        <div className="absolute left-[50%] top-[50%] md:left-[46%] md:[50%] lg:left-[50%] lg:top-[50%] -translate-x-1/2 -translate-y-1/2">
          <img src={middleImage} alt="Middle Icon" className="w-[70px] sm:!w-[90px] lg:!w-[110px] h-auto" />
        </div>
      )}

      {/* Right: Conditional Button */}
      {showButton && (
        <Button className={styles.header_btn} variant="primary" onClick={() => navigate(navUrl)}>
          {buttonName}
        </Button>
      )}
    </header>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setActiveTab: (data) => dispatch(setMyAccountActiveTab(data)),
})

export default connect(null, mapDispatchToProps)(Header);